import React, { Component } from 'react'
import Included from '../Included'
import FileComponent from './FileComponent'

const ALLOWED_FILE_EXTENSION = ['jpg', 'png', 'jpeg', 'pdf', 'txt'];

class Dropzone extends Component {

  constructor(props) {
    super(props);

    this.state = {
      error: null,
      fileList: []
    };

    this.onFilesSelected = this.onFilesSelected.bind(this);
    this.onFileClosed = this.onFileClosed.bind(this);
    this.onFormCancel = this.onFormCancel.bind(this);

    this.onDragOver = this.onDragOver.bind(this);
    this.onDragEnter = this.onDragEnter.bind(this);
    this.onDragLeave = this.onDragLeave.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
    this.onDrop = this.onDrop.bind(this);

  }

  onFilesSelected(e) {
    e.preventDefault();
    this.processFiles(e.currentTarget.files);
    e.currentTarget.value = null;
  }

  onFileClosed(index){
    let newFileList = [...this.state.fileList];
    newFileList.splice(index, 1);
    this.setState({
      fileList: newFileList
    });
  }

  onFormCancel(e){
    e.preventDefault();
    this.setState({
      error: null, 
      fileList: []
    })
  }

  onDragOver(e) {
    e.preventDefault();
    this.setIsDragOver(e);
  }

  onDragEnter(e) {
    e.preventDefault();
    this.setIsDragOver(e);
  }

  onDragLeave(e) {
    e.preventDefault();
    this.unsetIsDragOver(e);
  }

  onDragEnd(e) {
    e.preventDefault();
    this.unsetIsDragOver(e);
  }

  onDrop(e) {
    e.preventDefault();
    this.unsetIsDragOver(e);
    this.processFiles(e.dataTransfer.files);
  }

  setIsDragOver(e) {
    e.target.classList.add('is-dragover');
  }

  unsetIsDragOver(e) {
    e.target.classList.remove('is-dragover');
  }

  processFiles(fileList) {

      const { maxFileSize } = 100000000;

      let error = null;
      let totalFiles = fileList.length;
    
        for (var i = 0; i < totalFiles; i++) {

          const file = fileList.item(i);
          let isAllowedFileExtension = false;
          ALLOWED_FILE_EXTENSION.forEach(
            (item)=>{
              if (file.name.endsWith('.' + item)) {
                isAllowedFileExtension = true;
              } 
            })

          if (!isAllowedFileExtension) {
              error = `File type selected not allowed. Please select ${ALLOWED_FILE_EXTENSION} only.`;
          } else if (file.size === 0) {
              error = 'The selected file is empty. Please select another file to upload.';
          } else if (file.size > maxFileSize) {
              error = `The selected file exceeds the maximum file size of ${filesize(maxFileSize)}. Please select another file to upload.`;
          } else {
              this.setState(prevState => ({
                fileList: [...prevState.fileList, file],
                error: null
              }))
          }
        }

      this.setState({
          error
      });
  }

  render (){
    return(
    <section><a className="anchor" id="dropzone"></a>
      <h2>Dropzone</h2>

      <div className="soft">
      	<h3>Form Title</h3>
        <form>
          <ul className="form-fields soft-half max-width--70 grid">
            <li className="flush grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6 required">
              <label htmlFor="labelone">Label</label>
              <input id="labelone" type="text" className="text-input"/>
            </li>
            <li className="flush grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6 required">
              <label htmlFor="labeltwo">Label</label>
              <input id="labeltwo" type="text" className="text-input"/>
            </li>

            {
              this.state.fileList.length === 0 &&
              <li 
                onDragOver={this.onDragOver}
                onDragEnter={this.onDragEnter}
                onDragLeave={this.onDragLeave}
                onDragEnd={this.onDragEnd}
                onDrop={this.onDrop}
                className="flush grid__col-xs-12 grid__col-sm-12 grid__col-md-12 grid__col-lg-12">
                
                <label className="text--center soft-half is-droppable" htmlFor="files">
                  <div className="push-quarter--bottom">
                    <i className="fas fa-file-upload fa-2x" />
                  </div>
                  {
                    !this.state.error &&
                    <div>Drop file <strong>OR</strong> Click to upload</div>
                  }
                  {
                    this.state.error &&
                    <div className="dropzone__error-msg">{ this.state.error }</div>
                  }
                </label> 
                
                <input 
                  id="files" 
                  name="files[]"
                  type="file" 
                  className="hide"
                  multiple={true}
                  onChange={this.onFilesSelected}
                />
              </li>
            }

            <ul className="grid is-droppable dropzone__layout" style={{ display: this.state.fileList.length !== 0 ? 'flex': 'none'}}>
            {
              this.state.fileList.map((file, index, arr) => {
                return (              
                  
                    <li className="flush grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6 attachment__multiple">
                      <FileComponent 
                        file = {this.state.fileList[index]}
                        key = {index}
                        onFileClosed = {this.onFileClosed.bind(this, index)}
                      />  
                    </li>
                )
              })
            }

            {
              (this.state.fileList.length % 2) !== 0 &&
                <li className="flush grid__col-xs-12 grid__col-sm-12 grid__col-md-6 grid__col-lg-6 attachment__multiple">
                  
                  <label className="text--center soft-half border border-rounded" htmlFor="files">
                    <span className="attachment__meta push-quarter--bottom">
                      <i className="fas fa-plus fa-2x" />
                    </span>
                  </label>                     
                  <input 
                    id="files" 
                    name="files[]"
                    type="file" 
                    className="hide"
                    multiple={true} 
                    onChange={this.onFilesSelected}
                  />
                </li>
            }

            {
              this.state.fileList.length !== 0 && (this.state.fileList.length % 2) === 0 &&
              <li className="flush grid__col-xs-12 grid__col-sm-12 grid__col-md-12 grid__col-lg-12 attachment__multiple">
                  
                  <label className="text--center soft-half border border-rounded" htmlFor="files">
                    <span className="attachment__meta push-quarter--bottom">
                      <i className="fas fa-plus fa-2x" />
                    </span>
                  </label>                     
                  <input 
                    id="files" 
                    name="files[]"
                    type="file" 
                    className="hide"
                    multiple={true} 
                    onChange={this.onFilesSelected}
                  />
              </li>
            }
            
            </ul>

            <li className="flush grid__col-xs-12 grid__col-sm-12 grid__col-md-12 grid__col-lg-12 text--center flex-end">
              <button className="btn btn--secondary push--right" onClick={this.onFormCancel}>
                Cancel
              </button>
              <button className="btn">
                Submit
              </button>
            </li>

          </ul>
        </form>
      </div>

    <br/>
    <hr/>
    </section>
  )
}
}

export default Dropzone



// WEBPACK FOOTER //
// ./styleguide/components/sections/Dropzone.js